import { useEffect, useRef, useState } from "react";

export const CountdownTimer = ({
  duration,
  color = "#22C55E",
  onComplete,
  running,
  onTick,
  format = "auto", // "auto" | "minutes" | "seconds"
  warnAt = 10,
}) => {
  const [remaining, setRemaining] = useState(duration);
  const startRef = useRef(null);
  const rafRef = useRef(null);

  useEffect(() => {
    setRemaining(duration);
  }, [duration]);

  useEffect(() => {
    if (!running) {
      cancelAnimationFrame(rafRef.current);
      startRef.current = null;
      return;
    }
    startRef.current = performance.now();
    const startRemaining = remaining;

    const tick = (now) => {
      const elapsed = (now - startRef.current) / 1000;
      const next = Math.max(0, startRemaining - elapsed);
      setRemaining(next);
      if (onTick) onTick(next);
      if (next <= 0) {
        if (onComplete) onComplete();
        return;
      }
      rafRef.current = requestAnimationFrame(tick);
    };
    rafRef.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(rafRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [running, duration]);

  const seconds = Math.ceil(remaining);
  const minutes = Math.floor(seconds / 60);
  const secs = seconds % 60;
  const useMinFormat =
    format === "minutes" || (format === "auto" && duration >= 60);
  const display = useMinFormat
    ? `${minutes}:${String(secs).padStart(2, "0")}`
    : String(seconds);
  const danger = remaining <= warnAt && remaining > 0;
  const finished = remaining <= 0;

  return (
    <div
      data-testid="countdown-timer"
      className={`relative w-full max-w-2xl mx-auto bg-white border-4 border-[#1a1a1a] rounded-[2rem] shadow-hard-lg flex items-center justify-center aspect-[3/2] ${danger ? "shake" : ""}`}
      style={{ borderColor: "#1a1a1a", background: finished ? color : "#fff" }}
    >
      <div
        className="font-display font-black tabular-nums leading-none"
        style={{
          fontSize: "clamp(5rem, 18vw, 14rem)",
          color: danger ? "#ef4444" : "#1a1a1a",
        }}
      >
        {finished ? "¡FIN!" : display}
      </div>
      {running && !finished && (
        <div className="absolute top-3 left-3 sm:top-5 sm:left-5 font-mono text-xs uppercase tracking-[0.25em] font-bold bg-[#1a1a1a] text-white px-3 py-1 rounded-md">
          en vivo
        </div>
      )}
    </div>
  );
};

export default CountdownTimer;
